import { NavLink } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ContactInfo } from "../../arrays/ContactInfo";
import { SocialLinks } from "../../arrays/SocialLinks";

function Footer(props) {
    const { currentPage } = props;

    return (
        <footer>
            <section className="wrapper">
                {/* SECTION NAVIGATION */}
                {/* REVIEW - list pages in two columns; three columns? */}
                <section className="footerList navList">
                    <h3>Navigation:</h3>
                    <div className="navFlex">
                        <ul className="footerNav">
                            <li>
                                <h4><NavLink to="/">Home</NavLink></h4>
                            </li>
                            <li>
                                <h4><NavLink to="/acting">Actress</NavLink></h4>
                                <ul>
                                    <li>
                                        <NavLink to="/acting/media">Media</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/acting/resume">Resume</NavLink>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h4><NavLink to="/music">Musician</NavLink></h4>
                                <ul>
                                    <li>
                                        <NavLink to="/music/discography">Discography</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/music/about">About</NavLink>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </section>
                {/* !SECTION NAVIGATION */}

                {/* SECTION CONTACT INFO */}
                <section className="email">
                    <h3>Contact:</h3>
                    <div>
                        {ContactInfo[currentPage].agency !== "" ? 
                            <h4 className="agency">{ContactInfo[currentPage].agency}</h4>
                        :
                            ""
                        }
                        {ContactInfo[currentPage].phone !== "" ? 
                            <div className="info">
                                <FontAwesomeIcon
                                    icon="fa-solid fa-phone"
                                    className="icon"
                                />
                                <p>{ContactInfo[currentPage].phone}</p> 
                            </div>
                        :
                            ""
                        }
                        {ContactInfo[currentPage].email !== "" ? 
                            <div className="info">
                                <FontAwesomeIcon
                                    icon="fa-solid fa-envelope"
                                    className="icon"
                                />
                                <p>{ContactInfo[currentPage].email}</p>
                            </div>
                        :
                            ""
                        }
                    </div>
                </section>
                {/* !SECTION CONTACT INFO */}

                {/* SECTION SOCIAL MEDIA */}
                <section className="footerList">
                    <h3>Social Media:</h3>
                    <ul className="socialMedia">
                        {SocialLinks.map((social, i) => {
                            return (
                                social.sections.includes(currentPage) ?
                                    <li className="social" key={i}>
                                        <FontAwesomeIcon
                                            icon={social.icon}
                                            className={social.class}
                                        />
                                        <a href={social.link} target="_blank" rel="noreferrer">{social.name}</a>
                                    </li>
                                :
                                    ""
                            );
                        })}
                    </ul>
                </section>
                {/* !SECTION SOCIAL MEDIA */}
            </section>
            <p><FontAwesomeIcon
                icon="fa-regular fa-copyright"
            /> Caitlin Klotz 2026</p>
        </footer>
    );
}

export default Footer;
